import React from 'react'
import { Parallax, Background } from 'react-parallax';
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Promo = ({ props }) => {
  const data = useStaticQuery(graphql`
    query {
      imageOne: file(relativePath: { eq: "victoriaprime.jpg" }) {
        childImageSharp {
          fixed(width: 1600, height: 1135) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Parallax
      strength={-450}
    >
      <div className="text-center g-color-white g-overflow-hidden">
        <div className="u-block-hover--scale g-min-height-400 g-flex-middle g-bg-cover g-bg-size-cover g-bg-bluegray-opacity-0_3--after g-transition-0_5">
          <div className="g-flex-middle-item g-pos-rel g-z-index-1 g-py-50 g-px-20">
            <em className="d-inline-block info-v3-1__title g-font-style-normal g-font-size-22">Our economy needs a strong hemp supply chain</em>
            <h3 className="g-mb-15 g-font-size-40">We're forging one.</h3>
            <Link to="/signup" className="btn btn-md u-btn-outline-white g-font-weight-600 g-font-size-14 text-uppercase">
              Join the Movement
            </Link>
          </div>
        </div>
      </div>
      <Background className="custom-bg">
        <Img fixed={data.imageOne.childImageSharp.fixed} />
      </Background>
    </Parallax>
  )
}

export default Promo